<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生清單</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <ul class="nav nav-tabs" role="tablist">
              <li class="active">
                <router-link :to="'/workstudy'">工讀生清單</router-link>
              </li>
              <li v-if="isAdmin('stipendMage')">
                <router-link :to="'/workstudy/treaty'">設定隱私權宣告、管理辦法</router-link>
              </li>
              <li v-if="isAdmin('stipendMage')">
                <router-link :to="'/workstudy/scheduleSetting'">開放排班設定</router-link>
              </li>
            </ul>
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                <div class="col-md-3 form-group">
                  <label class="col-md-4" style="padding-right:0px;">姓名/學號：</label>
                  <div class="col-md-8">
                    <input type="text" name="name" class="form-control" v-model="search.keyword">　
                  </div>
                </div>
                <div class="col-md-3 form-group">
                  <label class="col-md-4">類型：</label>
                    <div class="col-md-8">
                      <select v-model="search.workstudyType" class="form-control">
                        <option :value="null">請選擇</option>
                        <option :value="2">勞雇</option>
                        <option :value="1">生活</option>
                      </select>
                    </div>
                </div>
                <div class="col-md-6 from-group">
                  聘僱期間：
                  <select v-model="search.beginYm">
                    <option value="">--請選擇--</option>
                    <option v-for="(o,i) in years" :key="i" :value="`${o.y}/${o.m}`">{{o.y}}年{{o.m}}月</option>
                  </select> -
                  <select v-model="search.endYm">
                    <option value="">--請選擇--</option>
                    <option v-for="(o,i) in years" :key="i" :value="`${o.y}/${o.m}`">{{o.y}}年{{o.m}}月</option>
                  </select>
                </div>
                <div class="col-md-12 text-center">
                  <a href="javascript:;" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                  <a href="javascript:;" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
                  <a href="javascript:;" @click.prevent="searchExport" class="btn-upload btn btn-primary" style="background-color:#ED9C28; border-color:#ED9C28;" align="right">匯出資料</a>　
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div style="float: left;">
                學年度預算：
                <div v-if="budgetWork">
                  <div class="budget-title">「聘僱/臨時」</div>
                  剩餘金額 <span class="money">{{ budgetWork.salary + budgetWork.laborInsurance + budgetWork.laborPension | numberWithCommas }}</span>
                  = 本薪 <span class="money">{{ budgetWork.salary | numberWithCommas }}</span>
                  + 勞保費 <span class="money">{{ budgetWork.laborInsurance | numberWithCommas }}</span>
                  + 勞退費 <span class="money">{{ budgetWork.laborPension | numberWithCommas }}</span>
                </div>
                <div v-if="budgetBursary">
                  <div class="budget-title">「生&emsp;&ensp;&emsp;活」</div>
                  剩餘金額 <span class="money">{{ budgetBursary.salary | numberWithCommas }}</span>
                  = 本薪 <span class="money">{{ budgetBursary.salary | numberWithCommas }}</span>
                </div>
              </div>
              <div class="s_tenr" align="right">
                <input ref="bursaryFile" type="file" @change="bursaryUpload()" style="display: none;" />
                <a v-if="pageAdmin" href="#" @click.prevent="openHourlyRateModal" class="btn-upload btn btn-primary">調整時薪</a>
                <a v-if="pageAdmin" href="#" @click.prevent="importBursary" class="btn-upload btn btn-primary">匯入生活助學金名單</a>
                <router-link to="/workstudy/create/2" class="btn-upload btn btn-primary">新增勞雇型工讀生</router-link>
                <!-- <router-link to="/workstudy/create/3" class="btn-upload btn btn-primary">新增臨時工讀生</router-link> -->
                <router-link to="/workstudy/schedule" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">單位檢視班表</router-link>
              </div>
              <div style="clear: both;"></div>
              <a v-if="pageAdmin" href="/bursary/files/生活助學金名單.xlsx">生活助學金名單(上傳範例)</a>
              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>

                    <th class="text-center" width="5%">筆數</th>
                    <th class="text-center" width="8%">帳號狀態</th>
                    <th class="text-center" width="8%">類型</th>
                    <th class="text-center" width="15%">申請單位</th>
                    <th class="text-center" width="10%">姓名</th>
                    <th class="text-center" width="10%">學號</th>
                    <th class="text-center" width="15%">聘僱期間</th>
                    <th class="text-center" width="8%">聘用資料</th>
                    <th class="text-center" width="8%">工作記錄</th>
                    <th class="text-center" width="8%">排班表</th>
                    <th class="text-center" width="5%" v-show="isAdmin('stipendMage')">刪除</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">

                    <td data-title="筆數" class="text-center">{{index + 1}}</td>
                    <td data-title="帳號狀態" class="text-center" v-if="item.accountStatus">啟用</td>
                    <td data-title="帳號狀態" class="text-center" v-else-if="item.workstudyType=='勞雇'">
                      <a href="#" @click.prevent="downloadResign(item.id)" download>停用</a>
                    </td>
                    <td data-title="帳號狀態" class="text-center" v-else>停用</td>
                    <td data-title="類型" class="text-center">{{item.workstudyType}}</td>
                    <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                    <td data-title="工讀生姓名" class="text-center">
                      <router-link :to="'/workstudy/info/' + item.id">{{item.studentName}}</router-link>
                    </td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="聘僱期間" class="text-center">{{item.workTime}}</td>
                    <td data-title="聘用資料" class="text-center" v-if="item.workstudyType!='勞雇'">無</td>
                    <td data-title="聘用資料" class="text-center" v-else-if="!item.hasDataFile">未填寫</td>
                    <td data-title="聘用資料" class="text-center" v-else>
                      <a href="#" @click.prevent="downloadEmpoly(item.id)" download>已填寫</a>
                    </td>
                    <td data-title="工作記錄" class="text-center">
                      <router-link v-if="item.workstudyType == '生活'" :to="'/workstudy/studyRecord/' + item.id">學習記錄</router-link>
                      <router-link v-else :to="'/workstudy/workRecord/' + item.id">工讀記錄</router-link>
                    </td>
                    <td data-title="排班" class="text-center">
                      <router-link :to="'/workstudy/schedule/' + item.id" v-if="(item.workstudyType!='勞雇'||item.hasDataFile)&&item.accountStatus">排班</router-link>
                    </td>
                    <td data-title="刪除" class="text-center" v-show="isAdmin('stipendMage')">
                      <a href="#" @click.prevent="deleteWorkstudy(item.id)" v-if="!item.hasDataFile && !item.hasSchedule">刪除</a>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- 時薪設定 Modal -->
    <div class="modal fade" id="hourlyRateModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" style="max-width:600px;">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            <h4 class="modal-title">時薪設定</h4>
          </div>
          <div class="modal-body">
            <!-- 新增/編輯表單 -->
            <div class="panel panel-default" style="margin-bottom:12px;">
              <div class="panel-body">
                <div class="form-inline">
                  <div class="form-group" style="margin-right:10px;">
                    <label style="margin-right:6px;">生效日期：</label>
                    <input type="date" class="form-control" v-model="hourlyRateForm.effectiveDate" />
                  </div>
                  <div class="form-group" style="margin-right:10px;">
                    <label style="margin-right:6px;">時薪（元）：</label>
                    <input type="number" class="form-control" v-model.number="hourlyRateForm.rate" min="1" style="width:90px;" />
                  </div>
                  <button class="btn btn-primary" @click="saveHourlyRate">
                    {{ hourlyRateForm.editId ? '修改' : '新增' }}
                  </button>
                  <button v-if="hourlyRateForm.editId" class="btn btn-default" @click="cancelHourlyRateEdit" style="margin-left:6px;">取消</button>
                </div>
              </div>
            </div>
            <!-- 列表 -->
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th class="text-center">生效日期</th>
                  <th class="text-center">時薪（元）</th>
                  <th class="text-center">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in hourlyRateList" :key="r.id">
                  <td class="text-center">{{ r.effectiveDate | formatDate }}</td>
                  <td class="text-center">{{ r.rate }}</td>
                  <td class="text-center">
                    <a href="#" @click.prevent="editHourlyRate(r)" style="margin-right:8px;">編輯</a>
                    <a href="#" @click.prevent="deleteHourlyRate(r.id)" style="color:red;">刪除</a>
                  </td>
                </tr>
                <tr v-if="hourlyRateList.length === 0">
                  <td colspan="3" class="text-center">尚無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      pageAdmin: false,
      search: {
        keyword: "",
        workstudyType: null,
        beginYm:"",
        endYm:""
      },
      list: [],
      budgetBursary: null,
      budgetWork: null,
      page: 0,
      hourlyRateList: [],
      hourlyRateForm: {
        editId: null,
        effectiveDate: "",
        rate: null
      }
    };
  },
  async mounted() {
    this.pageAdmin = await this.isAdmin("stipendMage");
    // 套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
    if(storeQryParam != null) {
      this.search = storeQryParam;
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }
    this.load(this.page);
    this.$http.get("/api/budget/remaining-budget-workstudy").then(a => {
      let list = a.body;
      if (list.length == 0) return;
      this.budgetBursary = list.filter(a => a.workstudyType == 1)[0];
      this.budgetWork = list.filter(a => a.workstudyType == 2)[0];
    });
  },
  methods: {
    load(page = 0) {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }

      if(this.search.beginYm && this.search.endYm){
        if(new Date(`${this.search.endYm}/01`) < new Date(`${this.search.beginYm}/01`)){
          alert("開始時間不能大於結束時間");
          return false;
        }
      }

      this.$http
        .get("/api/workstudy", {
          params: {
            keyword: this.search.keyword,
            workstudyType: this.search.workstudyType,
            beginYm: this.search.beginYm,
            endYm: this.search.endYm
          },
        })
        .then((a) => {
          this.list = a.body;
          this.$nextTick((b) => {
            const table = this.$refs.table;
            $(table).dataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁",
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                },
                {
                  targets: 8,
                  orderable: false,
                },
                {
                  targets: 9,
                  orderable: false,
                },
              ],
              // order: [5, "asc"],
              columns: [
                { width: "5%" },
                { width: "8%" },
                { width: "8%" },
                { width: "15%" },
                { width: "10%" },
                { width: "10%" },
                { width: "15%" },
                { width: "8%" },
                { width: "8%" },
                { width: "8%" },
                { width: "5%" },
              ],
              "initComplete": function () {
                $(table).dataTable().api().page(+page).draw('page');
              }
            });

          });
        });
    },
    searchClear() {
      this.search.keyword = "";
      this.search.workstudyType = null;
      this.search.beginYm = "";
      this.search.endYm = "";
      this.removeStore(`${this.$route.name}.qryParam`);
      this.removeStore(`${this.$route.name}.page`);
    },
    searchSubmit() {
      this.load();
    },
    importBursary() {
      $(this.$refs.bursaryFile).click();
    },
    bursaryUpload() {
      let file = this.$refs.bursaryFile.files[0];
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("請上傳EXCEL檔(xlsx)");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/api/workstudy/import-bursary", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((a) => {
          if (a.body.status) {
            if (a.body.msg) {
              alert(a.body.msg);
            } else {
              alert("匯入生活助學金名單成功");
            }
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    downloadEmpoly(id) {
      this.$http
        .post(
          "/api/workstudy/export-employ/" + id,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
    downloadResign(id) {
      this.$http
        .post(
          "/api/workstudy/export-resign/" + id,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        })
        .catch((res) => {
          if (res.status == 405) {
            alert("尚未填寫離職申請");
          }
        });
    },
    deleteWorkstudy(id) {
      this.$http
        .delete("/api/workstudy/" + id)
        .then((res) => {
          alert(res.body.msg);
          if (res.body.status == "success") {
            this.load();
          }
        })
        .catch((res) => {
          if (res.status == 405) {
            alert("刪除失敗。");
          }
        });
    },
    searchExport() {
      const url = "/api/workstudy/export-bursary?" +
      `${this.search.keyword ? `keyword=${this.search.keyword.trim()}&`: ""}` +
      `${this.search.workstudyType ? `workstudyType=${this.search.workstudyType}&`: ""}` +
      `${this.search.beginYm ? `beginYm=${this.search.beginYm}&`: ""}` +
      `${this.search.endYm ? `endYm=${this.search.endYm}`: ""}`;
      this.$http
        .post(url,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
    openHourlyRateModal() {
      this.cancelHourlyRateEdit();
      this.$http.get("/api/WorkstudyHourlyRate").then(res => {
        this.hourlyRateList = res.body.data || [];
      });
      $("#hourlyRateModal").modal("show");
    },
    editHourlyRate(row) {
      this.hourlyRateForm.editId = row.id;
      this.hourlyRateForm.effectiveDate = row.effectiveDate ? row.effectiveDate.substring(0, 10) : "";
      this.hourlyRateForm.rate = row.rate;
    },
    cancelHourlyRateEdit() {
      this.hourlyRateForm.editId = null;
      this.hourlyRateForm.effectiveDate = "";
      this.hourlyRateForm.rate = null;
    },
    saveHourlyRate() {
      if (!this.hourlyRateForm.effectiveDate) { alert("請填寫生效日期"); return; }
      if (!this.hourlyRateForm.rate || this.hourlyRateForm.rate <= 0) { alert("請填寫正確時薪"); return; }
      const payload = { effectiveDate: this.hourlyRateForm.effectiveDate, rate: this.hourlyRateForm.rate };
      const request = this.hourlyRateForm.editId
        ? this.$http.put(`/api/WorkstudyHourlyRate/${this.hourlyRateForm.editId}`, payload)
        : this.$http.post("/api/WorkstudyHourlyRate", payload);
      request.then(res => {
        if (res.body.status === "success") {
          alert(res.body.msg);
          this.cancelHourlyRateEdit();
          this.$http.get("/api/WorkstudyHourlyRate").then(r => { this.hourlyRateList = r.body.data || []; });
        } else {
          alert(res.body.msg);
        }
      });
    },
    deleteHourlyRate(id) {
      if (!confirm("確定要刪除此時薪設定嗎？")) return;
      this.$http.delete(`/api/WorkstudyHourlyRate/${id}`).then(res => {
        if (res.body.status === "success") {
          this.hourlyRateList = this.hourlyRateList.filter(r => r.id !== id);
        } else {
          alert(res.body.msg);
        }
      });
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return "";
      return val.substring(0, 10);
    }
  },
  computed:{
    years(){
      var result = [];
      for(let i=2020; i <= (new Date().getFullYear() + 1); i++){
        for(let m=1;m<=12;m++){
          result.push({y:i, m:m});
        }
      }
      return result
    },
  },
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name.startsWith("/workstudy/")) {
      this.setStore(`${this.$route.name}.qryParam`, this.search);
      this.setStore(`${this.$route.name}.page`, $(this.$refs.table).DataTable().page());
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
};
</script>

<style scoped>
  div.budget-title {
    display: inline-block;
    width: 90px;
  }
  span.money {
    color: red;
    font-weight: bold;
  }
</style>
